// Feature flags are a way of enabling features on specific environments.
// This is useful for features that are not ready to be released to production yet.
// Please note: flags that are live on all environments should be removed afterward.

const featureFlags = {
    festivalMyIDFAEnabled: process.env.NEXT_PUBLIC_FLAG_FESTIVAL_MYIDFA_ENABLED === '1' || false,
};

export default featureFlags;
